import { Core } from 'scss-base-sites/src/js/utilities';
import { $ } from 'scss-base-sites/src/js/helper';
import { Modal } from 'scss-base-sites/src/js/plugins';

Core.ready(() => {
    const trailerModal = $('#trailerModal');
    const trailerModal2 = $('#trailerModal2');
    if(trailerModal) {
        new Modal(trailerModal);
        new Modal(trailerModal2);
    }
});
